"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var Badge_1 = __importStar(require("../badge/Badge"));
var onTabItemClick = function (evt, selected, onClick, index) {
    evt.preventDefault();
    selected && onClick(selected, index);
};
var TabItem = function (props) {
    var classes = props.classes, tabTitle = props.tabTitle, selected = props.selected, contentId = props.contentId, iconName = props.iconName, badgeText = props.badgeText, onClick = props.onClick, index = props.index, collapsePadding = props.collapsePadding, //eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
    otherProps = __rest(props, ["classes", "tabTitle", "selected", "contentId", "iconName", "badgeText", "onClick", "index", "collapsePadding"]);
    var getTextAndIcon = function () {
        if (iconName) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Icon_1.default, { name: iconName }),
                react_1.default.createElement("span", null, tabTitle)));
        }
        else {
            return (tabTitle);
        }
    };
    return (react_1.default.createElement("li", __assign({ id: contentId + "-title", role: "presentation", className: "fds-tab" }, otherProps),
        react_1.default.createElement("a", { onClick: function (evt) { return onTabItemClick(evt, !selected, onClick, index); }, role: "tab", href: "#", "aria-selected": selected, className: classnames_1.default('fds-tab-link', { selected: selected }, classes), "data-content-id": contentId },
            getTextAndIcon(),
            badgeText && (react_1.default.createElement(Badge_1.default, { text: badgeText, theme: Badge_1.NumberedBadgeTheme.NUMBERED_PRIMARY })))));
};
TabItem.defaultProps = {
    selected: false
};
exports.default = TabItem;
